import { Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { isEmpty, map, forEach } from 'lodash';
import { IFormOptions, IDependentControl } from './form.interface'
import { PASSWORD_PATTERN, PASSWORD_PATTERN_ERROR } from 'src/app/shared/shared.const';

@Injectable({
    providedIn: 'root'
})
export class FormService {

    constructor() { }

    createForm(group): FormGroup {
        let form: FormGroup = new FormGroup({});
        forEach(group, (formOption: IFormOptions) => {
            let defaultValue = (formOption.defaultValue === null || formOption.defaultValue === undefined) ? '' : formOption.defaultValue;
            if (formOption.type === 'dropdown' && isEmpty(defaultValue)) {
                defaultValue = formOption.ddlOptions?.multiOption ? [] : null;
            }
            form.addControl(formOption.controlName, new FormControl(defaultValue));
            if (formOption.readonly) {
                form.controls[formOption.controlName].disable();
            }
            if (!isEmpty(formOption.validators)) {
                form.controls[formOption.controlName].setValidators(Validators.compose(this.setValidtions(formOption.validators, [])));
            }
        });
        return form;
    }

    setValidtions(validators, returnArr): any {
        map(validators, (value, key) => {
            switch (key) {
                case 'pattern':
                    returnArr.push(Validators.pattern(value));
                    break;
                case 'required':
                    if (value) {
                        returnArr.push(Validators.required);
                    }
                    break;
                case 'email':
                    if (value) {
                        returnArr.push(Validators.email);
                    }
                    break;
                case 'min':
                    returnArr.push(Validators.min(value));
                    break;
                case 'minLength':
                    returnArr.push(Validators.minLength(value));
                    break;
                case 'max':
                    returnArr.push(Validators.max(value));
                    break;
                case 'maxLength':
                    returnArr.push(Validators.maxLength(value));
                    break;
                case 'requiredTrue':
                    if (value) {
                        returnArr.push(Validators.requiredTrue);
                    }
                    break;
            }
        })
        return returnArr;
    }

    errorMessage(form: FormGroup, field: IFormOptions): any {
        const error = form.controls[field.controlName].errors;
        const label = field.label;
        const errorMsg = field.validatorsErrors;
        if (error) {
            if (error.required) {
                return errorMsg && errorMsg.required || `${label} is required`;
            } else if (error.pattern && error.pattern.requiredPattern == PASSWORD_PATTERN) {
                return errorMsg && errorMsg.pattern || PASSWORD_PATTERN_ERROR;
            } else if (error.email) {
                return errorMsg && errorMsg.email || `Please enter valid ${label}`;
            } else if (error.pattern) {
                return errorMsg && errorMsg.pattern || `Please enter valid ${label}`;
            } else if (error.matDatepickerMin || error.matDatepickerMax || error.matDatepickerParse) {
                return `Please enter valid ${label}`;
            } else if (error.min) {
                return errorMsg && errorMsg.min || `${label} should be greater than or equal to ${error.min.min}`;
            } else if (error.minlength) {
                return errorMsg && errorMsg.minLength || `${label} should have minimum ${error.minlength.requiredLength} characters`;
            } else if (error.max) {
                return errorMsg && errorMsg.max || `${label} should be less than or equal to ${error.max.max}`;
            } else if (error.maxlength) {
                return errorMsg && errorMsg.maxLength || `${label} should have maximum ${error.maxlength.requiredLength} characters`;
            } else if (error.passwordMissmatch) {
                return `Password and Confirm password should be same`;
            }
            return `invalid field`;
        }
    }

    dependentEvent(form: FormGroup, controls: IDependentControl[], value: string, arr): any[] {
        forEach(controls, key => {
            forEach(arr, field => {
                if (key.conrtols.indexOf(field.controlName) >= 0) {
                    if (value === key.value) {
                        form.controls[field.controlName].enable();
                    } else {
                        form.controls[field.controlName].disable();
                    }
                }
            })
        })
        return arr;
    }
}
